import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { CrossButton, OptionsContainerText } from '../../common/dropdown/styles';
import sortOrders from './constants';
import {
  buildOption,
  SDropdownContainer,
  SDropdownIcon,
  SOptionsContainer,
} from './common';

const SOptionsContainerText = styled(OptionsContainerText)`
  padding-left: 8px;
`;

const Separator = styled.div`
  height: 0px;
  border-bottom: 1px solid #EEF1F5;
  margin: 16px -20px 40px;
`;

export default function Mobile({
  sortOrder,
  setSortOrder,
  showOptions,
  toggleShowOptions,
}) {
  return (
    <>
      <SDropdownContainer className={`sort ${sortOrder === 'default' ? '' : 'active'}`} onClick={toggleShowOptions}>
        <SDropdownIcon className="icon-lw icon-lw-sort" />
      </SDropdownContainer>
      <SOptionsContainer className={showOptions ? 'slide-up' : 'slide-down'}>
        <CrossButton onClick={toggleShowOptions}>&#10005;</CrossButton>
        <SOptionsContainerText>Sort</SOptionsContainerText>
        <Separator />
        {sortOrders.map(o => buildOption({ ...o, sortOrder, onClick: setSortOrder }))}
      </SOptionsContainer>
    </>
  );
}

Mobile.propTypes = {
  sortOrder: PropTypes.string.isRequired,
  setSortOrder: PropTypes.func.isRequired,
  showOptions: PropTypes.bool.isRequired,
  toggleShowOptions: PropTypes.func.isRequired,
};
